export default{
    DATA_COLLECTION_LINK:"https://culturebiedev-uploadbucket.s3.amazonaws.com/samplefiles/Sample_Data_Collection.csv",
    BENCHMARK_LINK:"https://culturebiedev-uploadbucket.s3.amazonaws.com/defaultTopicLibrary_culturebie_surveys.csv",
    TOPIC_LIBRARY_LINK:"https://culturebiedev-uploadbucket.s3.amazonaws.com/samplefiles/BenchmarkFile.csv"
}